import {
  GET_LEAD_NOTES,
  GET_LEAD_NOTES_SUCCESS,
  GET_LEAD_NOTES_ERROR,
  CREATE_LEAD_NOTES,
  CREATE_LEAD_NOTES_SUCCESS,
  CREATE_LEAD_NOTES_ERROR,
  UPDATE_LEAD_NOTES,
  UPDATE_LEAD_NOTES_SUCCESS,
  UPDATE_LEAD_NOTES_ERROR,
  DELETE_LEAD_NOTES,
  DELETE_LEAD_NOTES_SUCCESS,
  DELETE_LEAD_NOTES_ERROR,
  GET_CALL_NOTES,
  GET_CALL_NOTES_SUCCESS,
  GET_CALL_NOTES_ERROR,
  CREATE_CALL_NOTES,
  CREATE_CALL_NOTES_SUCCESS,
  CREATE_CALL_NOTES_ERROR,
  UPDATE_CALL_NOTES,
  UPDATE_CALL_NOTES_SUCCESS,
  UPDATE_CALL_NOTES_ERROR,
  DELETE_CALL_NOTES,
  DELETE_CALL_NOTES_SUCCESS,
  DELETE_CALL_NOTES_ERROR,
} from "./actionTypes";

/* GET LEAD NOTES */
export const getLeadNotes = (action) => ({
  type: GET_LEAD_NOTES,
  payload: action
});

export const getLeadNotesSuccess = (data) => ({
  type: GET_LEAD_NOTES_SUCCESS,
  payload: data,
});

export const getLeadNotesError = (error) => ({
  type: GET_LEAD_NOTES_ERROR,
  payload: error,
});

/* CREATE LEAD NOTES */
export const createLeadNotes = (newNotes) => ({
  type: CREATE_LEAD_NOTES,
  payload: newNotes,
});

export const createLeadNotesSuccess = (data) => ({
  type: CREATE_LEAD_NOTES_SUCCESS,
  payload: data,
});

export const createLeadNotesError = (error) => ({
  type: CREATE_LEAD_NOTES_ERROR,
  payload: error,
});

/* UPDATE LEAD NOTES */
export const updateLeadNotes = (notes) => ({
  type: UPDATE_LEAD_NOTES,
  payload: notes,
});

export const updateLeadNotesSuccess = (data) => ({
  type: UPDATE_LEAD_NOTES_SUCCESS,
  payload: data,
});

export const updateLeadNotesError = (error) => ({
  type: UPDATE_LEAD_NOTES_ERROR,
  payload: error,
});

/* DELETE LEAD NOTES */
export const deleteLeadNotes = (notesId) => ({
  type: DELETE_LEAD_NOTES,
  payload: notesId,
});

export const deleteLeadNotesSuccess = (data) => ({
  type: DELETE_LEAD_NOTES_SUCCESS,
  payload: data,
});

export const deleteLeadNotesError = (error) => ({
  type: DELETE_LEAD_NOTES_ERROR,
  payload: error,
});

/* GET CALL NOTES */
export const getCallNotes = (action) => ({
  type: GET_CALL_NOTES,
  payload: action
});

export const getCallNotesSuccess = (data) => ({
  type: GET_CALL_NOTES_SUCCESS,
  payload: data,
});

export const getCallNotesError = (error) => ({
  type: GET_CALL_NOTES_ERROR,
  payload: error,
});

/* CREATE CALL NOTES */
export const createCallNotes = (newNotes) => ({
  type: CREATE_CALL_NOTES,
  payload: newNotes,
});

export const createCallNotesSuccess = (data) => ({
  type: CREATE_CALL_NOTES_SUCCESS,
  payload: data,
});

export const createCallNotesError = (error) => ({
  type: CREATE_CALL_NOTES_ERROR,
  payload: error,
});

/* UPDATE CALL NOTES */
export const updateCallNotes = (notes) => ({
  type: UPDATE_CALL_NOTES,
  payload: notes,
});

export const updateCallNotesSuccess = (data) => ({
  type: UPDATE_CALL_NOTES_SUCCESS,
  payload: data,
});

export const updateCallNotesError = (error) => ({
  type: UPDATE_CALL_NOTES_ERROR,
  payload: error,
});

/* DELETE CALL NOTES */
export const deleteCallNotes = (notesId) => ({
  type: DELETE_CALL_NOTES,
  payload: notesId,
});

export const deleteCallNotesSuccess = (data) => ({
  type: DELETE_CALL_NOTES_SUCCESS,
  payload: data,
});

export const deleteCallNotesError = (error) => ({
  type: DELETE_CALL_NOTES_ERROR,
  payload: error,
});

